import { invokeWsgRequest } from '../common/wsgCall'
import { generateNewToken } from './header'
import { AUTH_TOKEN_EXPIRED_CODE, REQUEST_ERROR_CODE, RETRY_LATER, INVALID_JWT_TOKEN } from '../common/appConstants'

/**
 * Perform api call to SKP RM service endpoints (getAccountLevel1, getAccountLevel2, getAccountLevel3),
 * and retry the call after regnerating JWT Token if WSG990 was received.
 * 
 * @param method method type of request
 * @param apiUrl url
 * @param requestBody request body
 * @param params parameters
 * @param header headers
 * @returns {object} response object
 */

export const getAccLevelResponse = async (method, apiUrl, requestBody, params, header) => {
  let response
  response = await invokeWsgRequest(method, apiUrl, requestBody, params, header)

  let tokenExpired = false
  if (response.errors) {
    response.errors.forEach(error => {
      if (error.code === AUTH_TOKEN_EXPIRED_CODE || error.code === INVALID_JWT_TOKEN) {
        tokenExpired = true
      }
    })
  }

  if (tokenExpired) { 
    const token = await generateNewToken()
    header.JWT = token
    response = await invokeWsgRequest(method, apiUrl, requestBody, params, header) 
  }

  if (response.success === true && response.statusCode === 200) {
    return response
  } 

  let requestError = false
  if (response.errors) {
    response.errors.forEach(error => {
      if (error.code.startsWith(REQUEST_ERROR_CODE)) {
        requestError = true
      }
    })
  }

  if (requestError) {
    throw response
  } else {
    throw new Error(RETRY_LATER)
  }
}
